import * as Status from '../../../constants/reservation/Status';
import StatusLabels from '../../../constants/reservation/StatusLabels';

export const DefaultValues = {
  id: null,
  outreachId: null,
  guestId: null,
  firstName: '',
  lastName: '',
  email: '',
  homeless: 0,
  streetAddress: '',
  apartment: '',
  city: '',
  state: '',
  zipCode: '',
  homePhone: '',
  workPhone: '',
  cellPhone: '',
  householdTotal: 1,
  programs: [],
  requestTime: '',
  status: Status.ACTIVE,
  note: ''
};

export const StatusOptions = [
  {
    value: Status.PENDING,
    label: StatusLabels[Status.PENDING]
  },
  {
    value: Status.ACTIVE,
    label: StatusLabels[Status.ACTIVE]
  },
  {
    value: Status.CONFIRMED,
    label: StatusLabels[Status.CONFIRMED]
  },
  {
    value: Status.REJECTED,
    label: StatusLabels[Status.REJECTED]
  },
  {
    value: Status.CANCELED,
    label: StatusLabels[Status.CANCELED]
  }
];
